import React from 'react';
import {Tooltip, tooltipClasses} from '@mui/material';
import {styled, useTheme} from '@mui/material/styles';

const CustomTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} arrow classes={{popper: className }} />
    ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#EEEBF8",
        // color: "#000000de",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#EEEBF8",
        color: theme.palette.primary.main,
        fontSize: "14px",
        padding: "10px",
        borderRadius: theme.shape.borderRadius,
    },
}));

export default CustomTooltip